import * as v from 'valibot';
import { pii, secret } from './domain-string.js';
export const EmailAddress = pii('email-address');
export const Password = secret('password');
export const PasswordHash = secret('password-hash');
export const Credentials = v.object({
    email: EmailAddress,
    password: Password,
});
//# sourceMappingURL=credentials.js.map